module.exports = "<div class=\"module\" (click)=\"selectModule(module.value)\" [class.active]=\"isSelected(module.value)\">\r\n  <div>\r\n    <img [src]=\"baseHref+module.img\">\r\n  </div>\r\n  <span class=\"title\" [innerHtml]=\"module.value\"></span>\r\n  <span class=\"description\" *ngIf=\"module.description\">{{module.description}}</span>\r\n  <span class=\"prix\" *ngIf=\"hasPrix()\">{{stringprix}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/module/module.component.html
// module id = ../../../../../src/app/components/utils/module/module.component.html
// module chunks = main